import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useSatUiDiagnose } from "@/lib/useSatUiDiagnose";

/**
 * Control de previsualización UI diagnóstico SAT (desarrollo).
 * En producción (.exe) el servidor envía ui_diagnose_enabled=false y este bloque no se muestra.
 */
export default function SatUiDiagnoseSettings() {
  const {
    enabled,
    serverEnabled,
    loading,
    isDev,
    devOverride,
    setDevOverride,
    reload,
  } = useSatUiDiagnose();

  if (!isDev && !serverEnabled) return null;

  const effectiveLabel = enabled
    ? "Modo pruebas / web — banners técnicos visibles"
    : "Modo producción / .exe — UI limpia (sin banners técnicos)";

  return (
    <div
      className="rounded-md border border-violet-200 bg-violet-50/80 px-4 py-3 space-y-3 text-sm"
      data-testid="sat-ui-diagnose-settings"
    >
      <div>
        <p className="font-semibold text-violet-950 m-0">Switch de diagnóstico SAT (UI)</p>
        <p className="text-xs text-violet-900/80 m-0 mt-1 leading-relaxed">
          Controla la visibilidad del banner azul de cola quirúrgica y del aviso ámbar del Carril 2 en
          Clientes. El motor seguro (metadatos + cola de 12 s) sigue activo en el backend.
        </p>
      </div>
      <p className="text-xs text-slate-700 m-0">
        Servidor: <strong>{serverEnabled ? "diagnóstico ON" : "producción (oculto)"}</strong>
        {isDev ? (
          <>
            {" "}
            · Vista actual: <strong>{effectiveLabel}</strong>
          </>
        ) : null}
      </p>
      {isDev ? (
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center gap-2">
            <Switch
              id="sat-ui-diagnose-dev-switch"
              checked={enabled}
              onCheckedChange={(on) => setDevOverride(on)}
              data-testid="sat-ui-diagnose-dev-switch"
            />
            <Label htmlFor="sat-ui-diagnose-dev-switch" className="text-xs cursor-pointer">
              Previsualizar banners de diagnóstico
            </Label>
          </div>
          {devOverride !== null ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="text-xs h-8"
              onClick={() => {
                setDevOverride(null);
                reload();
              }}
            >
              Usar valor del servidor
            </Button>
          ) : null}
        </div>
      ) : (
        <p className="text-[11px] text-slate-600 m-0">
          Variable de entorno: <code className="font-mono">VF_SAT_UI_DIAGNOSE_ENABLED</code>
        </p>
      )}
    </div>
  );
}
